<script setup>
import { computed, onMounted, ref } from 'vue';

const formsLoaded = ref(false);
const forms = ref([]);
const formSearch = ref('');

const filteredForms = computed(() => {
    const q = formSearch.value.trim().toLowerCase();
    const sorted = [...forms.value].sort((a, b) => a.title.localeCompare(b.title));
    if (!q) return sorted;
    return sorted.filter((form) => form.title.toLowerCase().includes(q));
});

const loadForms = async () => {
    formsLoaded.value = false;
    const res = await axios.get(route('api.form.index'), { params: { only_chartable: 1 } });
    forms.value = res.data.forms;
    formsLoaded.value = true;
};

onMounted(() => {
    loadForms();
});
</script>

<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4">
                    <h1>{{ _mft('form:chart.pageTitle') }}</h1>
                </div>

                <template #navigation>
                    <a :href="route('forms.index')" class="mf-link text-xs">{{ _mft('form:form.domainNamePlural') }}</a>
                </template>
            </frosted-bar>
        </div>

        <div class="mt-12">
            <div v-if="!formsLoaded" class="flex justify-center">
                <mf-spinner-medium class="w-24 h-12" />
            </div>

            <div v-else>
                <div class="mb-4">
                    <input-text
                        v-model:content="formSearch"
                        :label="_mft('form:chart.searchForms')"
                    />
                </div>

                <list-basic>
                    <list-basic-item v-if="filteredForms.length === 0">
                        <div class="text-center text-gray-400 py-2">{{ _mft('form:chart.noFormsFound') }}</div>
                    </list-basic-item>

                    <list-basic-item
                        v-for="form in filteredForms"
                        :key="form.id"
                    >
                        <template #title>
                            <a :href="route('forms.charts.form', form.id)" class="mf-link">{{ form.title }}</a>
                        </template>
                        <template #actions>
                            <a :href="route('forms.charts.form', form.id)">
                                <button-secondary size="sm">{{ _mft('form:chart.charts') }}</button-secondary>
                            </a>
                        </template>
                    </list-basic-item>
                </list-basic>
            </div>
        </div>
    </div>
</template>
